import React from 'react';
import { getNewPlatformIconWithBackground } from '../../../widgets/components/online-platform-icon';
import { IconWrapper } from './cell-styles';

export function PlatformLinkCell({ value }) {
  if (!value?.listingUrl) return <div />; // must return a component

  const { platform, listingUrl, live } = value;
  const PlatformLinkIcon = getNewPlatformIconWithBackground(platform);

  const iconOnClick =
    live === 'Live' ? () => window.open(listingUrl, '_blank') : () => null;
  const liveStyle = '';
  const notLiveStyle = `
    opacity: 0.8;
    filter: grayscale(90%);
    > svg, img {
      cursor: inherit;
    }
  `;

  return (
    <IconWrapper css={live === 'Live' ? liveStyle : notLiveStyle}>
      <PlatformLinkIcon
        onClick={iconOnClick}
        showTooltip
        tooltipPosition="left"
      />
    </IconWrapper>
  );
}
